import { TableColumn } from "../table/TableColumn";

const IPRangePreferenceColumns: TableColumn[] = [
    {
        heading: "Start IP",
        accessor: "startIpAddress",
        isNumeric: false,
        id: 0,
        active: true,
        translationKey: "startIpAddress",
        isDefault: true,
    },
    {
        heading: "End IP",
        accessor: "endIpAddress",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "endIpAddress",
        isDefault: true,
    },
];

export default IPRangePreferenceColumns
